import { Accordion } from 'react-bootstrap'
import gift from '../../Assets/Images/plp-banner-desktop.png'
const Features = () => {
    return (
        <>
            <div className="container py-5">
                <div className="row justify-content-between align-items-center">
                    <div className="col-12">
                        <h2 className='text-center fw-bold'>FAQs </h2>

                    </div>

                    <div className="col-lg-5">
                        <Accordion>
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>High Conversion Rate</Accordion.Header>
                                <Accordion.Body>
                                    PopGop is a trusted premium diaper
                                    brand loved by parents.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header> Attractive Commission</Accordion.Header>
                                <Accordion.Body>
                                    Earn up to 10% per sale.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header> Real-Time Tracking</Accordion.Header>
                                <Accordion.Body>
                                    Access your dashboard to monitor clicks, sales, and earnings.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="3">
                                <Accordion.Header> Easy to Share</Accordion.Header>
                                <Accordion.Body>
                                    Promote through social media, blogs, WhatsApp, or websites.
                                </Accordion.Body>

                            </Accordion.Item>
                            <Accordion.Item eventKey="4">
                                <Accordion.Header> Exclusive Offers </Accordion.Header>
                                <Accordion.Body>
                                    Affiliates get early access to PopGop deals & discounts to boost sales.
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>

                    </div>

                    <div className="col-lg-5 pt-5">
                        <img src={gift} width={"100%"} className='rounded-4' alt="" />
                    </div>
                </div>
            </div>
        </>
    )
}

export default Features